
import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Table } from 'react-bootstrap';

// import NavBar_v03Responsive from './NavBar_v03a_Responsive_component';
import { IAppConfig, IAddress, IOperatingHours } from "../../App_v01_Interfaces";

import { CompanyInfoCard, CompanyInfo  } from "./CompanyInfoCard";
interface AppConfigProps{
  appConfig: IAppConfig;
}



const Contact_LegacyInsurance_v01: React.FC<AppConfigProps> = ({ appConfig }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [form_DATA, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    domainName: window.location.hostname,
    itemCategory: 'Customer',
    itemClass: 'feedback',
    itemType: 'legacy.contactus',
    clientVersion: "v01a",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

const isTestMode = false; // ✅ Toggle this to false in production

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setIsProcessing(true);

  if (isTestMode) {
    console.log('🚧 TEST MODE: Skipping API call.');
    console.table({
      domainName: form_DATA.domainName,
      customerName: form_DATA.name,
      emailAddress: form_DATA.email,
      message: form_DATA.message,
      itemCategory: form_DATA.itemCategory,
      itemClass: form_DATA.itemClass,
      itemType: form_DATA.itemType,
      clientVersion: form_DATA.clientVersion,
    });

    setFormSubmitted(true);
    setErrorMessage('');
    return;
  }

  try {
    const response = await fetch(appConfig.contactPageAPIUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        domainName: form_DATA.domainName,
        customerName: form_DATA.name,
        emailAddress: form_DATA.email,
        message: form_DATA.message,

        itemCategory: form_DATA.itemCategory,
        itemClass: form_DATA.itemClass,
        itemType: form_DATA.itemType,
        clientVersion: form_DATA.clientVersion,
      }),
    });

    if (!response.ok) {
      setIsProcessing(false);
      throw new Error(`Server responded with ${response.status}`);
    }

    setFormSubmitted(true);
    setIsProcessing(false);
    setErrorMessage('');
  } catch (err: any) {
    setIsProcessing(false);
    setErrorMessage('Cloud Network Error. This form is offline. Please send your message using regular email. Thank you! :)');
    console.error(err);
  }
};




  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   try {
  //     const response = await fetch(appConfig.contactPageAPIUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         domainName: formData.domainName,
  //         customerName: formData.name,
  //         emailAddress: formData.email,
  //         message: formData.message,
  //         itemCategory: formData.itemCategory,
  //         itemClass: formData.itemClass,
  //         itemType: formData.itemType,
  //       }),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Server responded with ${response.status}`);
  //     }

  //     setFormSubmitted(true);
  //     setErrorMessage('');
  //   } catch (err: any) {
  //     setErrorMessage('Cloud Network Error. This form is offline. Please send your message using regular email. Thank you! :)');
  //     console.error(err);
  //   }
  // };

  return (
    <>
      {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

      <section className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>{appConfig.ContactUsPage.Headline}</Col>
          </Row>

          <Row>
            <Col md={6}>
              {!formSubmitted ? (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="name">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your name"
                      value={form_DATA.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      value={form_DATA.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="message">
                    <Form.Label>Your Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="What can we help you with?"
                      value={form_DATA.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <input type="hidden" id="domainName" value={form_DATA.domainName} />
                  <input type="hidden" id="itemCategory" value={form_DATA.itemCategory} />
                  <input type="hidden" id="itemClass" value={form_DATA.itemClass} />
                  <input type="hidden" id="itemType" value={form_DATA.itemType} />

                  <Button variant="primary" type="submit"  disabled={isProcessing}>
                    {isProcessing ? 'Processing...' : 'Send Message'}
                  </Button>
                </Form>
              ) : (
                <div className="p-3 rounded border" style={{ backgroundColor: 'var(--bs-success-bg-subtle)' }}>
                  <h5>Thank you! A representative will be following up with you shortly.</h5>
                  <p><strong>Name:</strong> {form_DATA.name}</p>
                  <p><strong>Email:</strong> {form_DATA.email}</p>
                  <p><strong>Message:</strong> {form_DATA.message}</p>
                  {/* <p><strong>Domain:</strong> {formData.domainName}</p> */}
                  {/* <p><strong>Category:</strong> {formData.itemCategory}</p> */}
                  {/* <p><strong>Class:</strong> {formData.itemClass}</p> */}
                  {/* <p><strong>Type:</strong> {formData.itemType}</p> */}
                </div>
              )}

              {errorMessage && (
                <Alert variant="danger" className="mt-3">
                  {errorMessage}
                </Alert>
              )}
            </Col>

            <Col md={6}>
              {/* <h5>Contact Details</h5> */}


              {/* CUSTOM SECTION - NEEDED TO ADD ATRIUM NAME ON THE PAGE */}
              <strong>{appConfig.companyLegalName}</strong>
              <br></br>
                {appConfig.address.street1}, {appConfig.address.street2}
                <br />
                {appConfig.address.city}, {appConfig.address.state} {appConfig.address.zip}
              <br></br>
             
                <Container className="p-0 mt-1">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "max-content max-content", // one column for labels, one for numbers
                      columnGap: "6px",  // tight gap between label and number
                      rowGap: "1px",
                      alignItems: "baseline",
                    }}
                  >
                    <span className="fw-boldx">Phone:</span>
                    <span><a href={"tel:" + appConfig.companyMainPhone}>{appConfig.companyMainPhone}</a></span>
                    <span className="fw-boldx">Fax:</span>
                    <span><a href={"tel:" + "303-337-5434"}>{"(303) 337-5434"}</a></span>
                  </div>
                </Container>
             
             
             
             
             
              <br></br>

              <strong>Atrium Insurance Group</strong><br></br>
                  6970 S. Holly Cir. Suite: 104, 
                  <br />
                  Centinnial, CO, 80122
                  <br></br>
              
               <Container className="p-0 mt-1">
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "max-content max-content", // one column for labels, one for numbers
                      columnGap: "6px",  // tight gap between label and number
                      rowGap: "4px",
                      alignItems: "baseline",
                    }}
                  >
                    <span className="fw-boldx">Phone:</span>
                    <span><a href={"tel:" + appConfig.companyMainPhone}>{appConfig.companyMainPhone}</a></span>

                    <span className="fw-boldx">Fax:</span>
                    <span><a href={"tel:" + "303-337-5434"}>{"(303) 337-5434"}</a></span>
                  </div>
                </Container>


              {/* 
                  Phone: <a href={"tel:" + appConfig.companyMainPhone}>{appConfig.companyMainPhone}</a><br></br>
                  Fax:   <a href={"tel:" + "303-337-5434"}>{"303-337-5434"}</a> 
              */}



          
              <br></br>

              <strong><p>Email: {appConfig.infoeMail}</p></strong>
              {/* <p>Phone: {appConfig.companyMainPhone}</p> */}

            

              <h5>Service Hours</h5>
              <p>
                {appConfig.operatingHours.MF}
                <br />
                {appConfig.operatingHours.SA}
                <br />
                {appConfig.operatingHours.SU}
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact_LegacyInsurance_v01;




const Contact_v01a: React.FC<AppConfigProps> = ({ appConfig }) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    domainName: window.location.hostname,
    itemCategory: 'Customer',
    itemClass: 'WebForm',
    itemType: 'Feedback',
    clientVersion: "v01a",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch( appConfig.contactPageAPIUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          domainName:     formData.domainName,
          customerName:   formData.name,
          emailAddress:   formData.email,
          message:        formData.message,
          itemCategory:   formData.itemCategory,
          itemClass:      formData.itemClass,
          itemType:       formData.itemType,
          clientVersion:  formData.clientVersion,
        }),
      });

      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }

      setFormSubmitted(true);
      setErrorMessage('');
    } catch (err: any) {
      setErrorMessage('Cloud Network Error. This form is offline. Please send your message using regular email. Thank you! :)');
      console.error(err);
    }
  };

  return (
    <>
      {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

      <section className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>{appConfig.ContactUsPage.Headline}</Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="message">
                  <Form.Label>Your Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="What can we help you with?"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                {/* Hidden Fields */}
                <input type="hidden" id="domainName"    value={formData.domainName} />
                <input type="hidden" id="itemCategory"  value={formData.itemCategory} />
                <input type="hidden" id="itemClass"     value={formData.itemClass} />
                <input type="hidden" id="itemType"      value={formData.itemType} />

                <Button variant="primary" type="submit">
                   Send Message
                </Button>
              </Form>

              {formSubmitted && !errorMessage && (
                <Alert variant="success" className="mt-3">
                  Thank you! A representative will be following up with you shortly.
                </Alert>
              )}

              {errorMessage && (
                <Alert variant="danger" className="mt-3">
                  {errorMessage}
                </Alert>
              )}
            </Col>

            <Col md={6}>
              {/* <h5>Contact Details</h5> */}
              <p><strong>{appConfig.companyLegalName}</strong></p>
              <p>
                {appConfig.address.street1}, {appConfig.address.street2}
                <br />
                {appConfig.address.city}, {appConfig.address.state} {appConfig.address.zip}
              </p>
              <p>Email: {appConfig.infoeMail}</p>
              <p>Phone: {appConfig.companyMainPhone}</p>

              <h5>Service Hours</h5>
              <p>
                {appConfig.operatingHours.MF}
                <br />
                {appConfig.operatingHours.SA}
                <br />
                {appConfig.operatingHours.SU}
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

// export default Contact_v01a;




 const Contact_v01_original: React.FC<AppConfigProps> = ({appConfig}) => {

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);

    // In production: Send data to a backend or service like EmailJS / Formspree
  };

  return (

    <>
     {/* <NavBar_v03Responsive appConfig={appConfig} /> */}
    
    <section className="py-5">
      <Container>
        <Row className="mb-4">
          <Col>
           
           {appConfig.ContactUsPage.Headline}

          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Your Name</Form.Label>
                <Form.Control type="text" placeholder="Enter your name" required />
              </Form.Group>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label>EMail address</Form.Label>
                <Form.Control type="email" placeholder="Enter your email" required />
              </Form.Group>

              <Form.Group className="mb-3" controlId="message">
                <Form.Label>Your Message</Form.Label>
                <Form.Control as="textarea" rows={4} placeholder="What can we help you with?" required />
              </Form.Group>

              <Button variant="primary" type="submit">
                Send Message
              </Button>
            </Form>

            {formSubmitted && 
                              (
                                <Alert variant="success" className="mt-3">
                                  {/* Thanks! We’ll get back to you shortly. */}
                                  Cloud Network Error.  This form is offline. Please send your message using regular email.  Thank you! :)
                                </Alert>
                              )
            }
          </Col>

          <Col md={6}>
            {/* <h5>Contact Details</h5> */}
            <p><strong>{appConfig.companyLegalName}</strong></p>
            <p>{appConfig.address.street1}, {appConfig.address.street2}<br />{appConfig.address.city}, {appConfig.address.state} {appConfig.address.zip}</p>
            <p>EMail: {appConfig.infoeMail}</p>
            <p>Phone: {appConfig.companyMainPhone}</p>

            <h5>Service Hours</h5>
            <p>{appConfig.operatingHours.MF}<br />{appConfig.operatingHours.SA}<br />{appConfig.operatingHours.SU}</p>
          </Col>
        </Row>
      </Container>
    </section>
    </>

  );
};

// export default Contact_v01_original;




// const Contact_v01: React.FC<AppConfigProps> = ({appConfig}) => {
//   return (
//     <>
//       {/* <Navbar_v01 appConfig={appConfig}/> */}
//       <NavBar_v03LeftRight appConfig={appConfig} />

//       <div className='container mt-5'>
//         <h2>Contact_v01</h2>
//         <p>Welcome to the Contact_v01 page of Cost Crusher Insurance.</p>
//       </div>
//     </>
//   );
// };

// export default Contact_v01;
